import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GeneralService, GlobalService, LocalStorageService } from '../index.service';

@Injectable({
  providedIn: 'root'
})
export class LandingPageGuard  {
  constructor(
    private storage:LocalStorageService,
    private router:Router,
    private globalService:GlobalService,
    private generalService:GeneralService
  ){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(this.storage.getItem('token')){
        this.redirectPage()
        return false
      }else{
        return true
      }
  }
  redirectPage(){
    this.router.navigate([this.globalService.accountUrl()])
  }
}
